import * as React from 'react';
import { DEFAULT_SVG_COLOR, SVGIcon, SVGIconProps } from '../SvgIcon';

export const CallbacksIcon = (props: SVGIconProps) => {
    return (
        <SVGIcon
            width="16"
            height="17"
            viewBox="0 0 16 17"
            {...props}
            fill="none"
            style={{ fill: 'none !important' }}
            className="event-icon"
        >
            <g clipPath="url(#clip0_410_3672)">
                <path
                    d="M12.2632 1.38336L15.1487 4.05003L12.2632 6.71669"
                    stroke={props.fill || DEFAULT_SVG_COLOR}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.16406 7.38338V6.71672C2.16406 6.00947 2.46807 5.33119 3.0092 4.8311C3.55033 4.331 4.28426 4.05005 5.04953 4.05005H15.1487"
                    stroke={props.fill || DEFAULT_SVG_COLOR}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.04953 14.7167L2.16406 12.05L5.04953 9.38336"
                    stroke={props.fill || DEFAULT_SVG_COLOR}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1487 8.71674V9.3834C15.1487 10.0906 14.8447 10.7689 14.3035 11.269C13.7624 11.7691 13.0285 12.0501 12.2632 12.0501H2.16406"
                    stroke={props.fill || DEFAULT_SVG_COLOR}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_410_3672">
                    <rect
                        width="17.3128"
                        height="16"
                        fill="white"
                        transform="translate(0 0.0500488)"
                    />
                </clipPath>
            </defs>
        </SVGIcon>
    );
};
